import { FindingType } from "~/operations";

/**
 * List of finding types that are allowed to be displayed and filtered
 * in the asset findings views.
 */
export const ALLOWED_FINDING_TYPES: FindingType[] = [
  FindingType.Check,
  FindingType.Cve,
  FindingType.Advisory,
  FindingType.Informational,
  FindingType.Malware,
  FindingType.Security,
  FindingType.Threat,
];
